import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Api\Workspace\UpdateTrialEndsAtController::__invoke
* @see app/Http/Controllers/Admin/Api/Workspace/UpdateTrialEndsAtController.php:13
* @route '/api/admin/workspaces/subscriptions/trial-ends-at'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/api/admin/workspaces/subscriptions/trial-ends-at',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Api\Workspace\UpdateTrialEndsAtController::__invoke
* @see app/Http/Controllers/Admin/Api/Workspace/UpdateTrialEndsAtController.php:13
* @route '/api/admin/workspaces/subscriptions/trial-ends-at'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Api\Workspace\UpdateTrialEndsAtController::__invoke
* @see app/Http/Controllers/Admin/Api/Workspace/UpdateTrialEndsAtController.php:13
* @route '/api/admin/workspaces/subscriptions/trial-ends-at'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

const trialEndsAt = {
    update: Object.assign(update, update),
}

export default trialEndsAt